/**
 * Affiche-t-on la comparaison abonnés / non-abonnés ?
 *
 * Dans la query string, à côté de la période et pour les mêmes raisons : le
 * choix survit au rechargement, l'URL est partageable (« regarde l'écart sur
 * les 90 derniers jours » est un lien), et ça ne coûte aucune bibliothèque de
 * plus.
 *
 * Désactivé par défaut. La comparaison remplace les graphiques globaux plutôt
 * que de s'y ajouter — la page garde le même nombre de cartes, elle en change
 * seulement la lecture. C'était la demande : pas de graphiques partout.
 */

import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const PARAM = 'cmp';

export function useComparePref(): [boolean, (next: boolean) => void] {
  const [searchParams, setSearchParams] = useSearchParams();

  const compare = searchParams.get(PARAM) === '1';

  const setCompare = useCallback(
    (next: boolean) => {
      const params = new URLSearchParams(searchParams);
      if (next) {
        params.set(PARAM, '1');
      } else {
        // Retire le parametre au lieu de le mettre a `0` : l'URL par defaut
        // reste propre, et `?cmp=0` ne trainera pas dans les liens partages.
        params.delete(PARAM);
      }
      // `replace` : basculer l'interrupteur ne doit pas empiler une entree
      // d'historique, sinon « precedent » le rebascule au lieu de quitter.
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return [compare, setCompare];
}
